import NotificationPage from '../components/NotificationPage';
import { getUsername } from '../utils/userUtils';
import { useAuth } from '../contexts/AuthContext';

const getNameFromUser = (user: unknown): string | undefined => {
  if (!user || typeof user !== 'object') return undefined;
  const record = user as Record<string, unknown>;

  const username = record.username;
  if (typeof username === 'string' && username.trim()) return username;

  const name = record.name;
  if (typeof name === 'string' && name.trim()) return name;

  return undefined;
};

const AuthError = () => {
  const { user } = useAuth();

  // Prefer MSAL account (accounts[0]) when available; fall back to stored account info (Teams flow)
  const userName =
    getNameFromUser(user) ||
    getUsername() ||
    'Unknown User';

  return (
    <NotificationPage
      content={
        <>
          <p>User {userName} lacks of privilege to access reports.</p>
          <p>Please contact your administrator for further information.</p>
        </>
      }
      enableRotation={false}
    />
  );
};

export default AuthError;
